import React, { PureComponent } from "react";
import {
  Metric,
  Error,
  selectFormat,
  // MAIN_COLORS,
} from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

// import {
//   BarChart,
//   Bar,
//   Cell,
// } from "recharts";

class YesterdaysSummary extends PureComponent {
  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={260} />;
    }

    // const renderMetrics = () =>
    //   data.chart
    //     .filter((item) => item.name === "Platforms Current")
    //     .map((item, i) => {
    //       const key = Object.entries(item)[1];
    //       const value = key[1];
    //       return (
    //         <div key={i} className="mb-2">
    //           <div className="d-flex info-detail-list align-items-center ">
    //             <div
    //               className="info-detail-icon"
    //               style={{ backgroundColor: MAIN_COLORS[i] }}
    //             ></div>
    //             <div className="mr-auto info-detail info-detail-label">
    //               {key}
    //             </div>
    //             <div className="mr-auto">
    //               <Metric value={value} size={"xs"} />
    //             </div>
    //           </div>
    //         </div>
    //       );
    //     });

    // const renderBars = (data) => {
    //   let bars = [];
    //   let all_bars = [];

    //   for (let i = 0; i <= data.length - 1; i++) {
    //     Object.keys(data[i]).forEach((bar, key) => {
    //       if (bar !== "name") {
    //         all_bars.push(bar);
    //       }
    //     });
    //   }

    //   all_bars.forEach((bar, i) => {
    //     bars.push(
    //       <Bar key={i} dataKey={bar} stackId="stack" barSize={40}>
    //         <Cell fill={MAIN_COLORS[i]} />
    //       </Bar>
    //     );
    //   });

    //   return bars;
    // };

    return (
      <>
        <div className="row">
          <div className="col-12">
            <div className="flex">
              <span>
                Date:{" "}
                <span className="column-header">
                  {selectFormat("date", data.meta.date, "dddd MMMM Do YYYY")}
                </span>
                <span className="mx-2">|</span>
              </span>

              <span>
                Match Day:{" "}
                <span className="column-header">{data.meta.match_day}</span>{" "}
                <span className="mx-2">|</span>
              </span>

              <span>
                Games Played:{" "}
                <span className="column-header">{data.meta.games_played}</span>
                <span className="mx-2">|</span>
              </span>

              {/* <span>
                Total Games to Date:{" "}
                <span className="column-header">
                  {data.meta.total_games_to_date}
                </span>
              </span> */}
            </div>
          </div>
          <div className="col-12">
            <small className="info-format">
              All values are in Thousands (000)
            </small>
          </div>
        </div>

        <div className="mt-4 row">
          <div className="col-12 col-lg-8">
            <div className="row">
              <div className="mb-5 col-6">
                <Heading size={4}>
                  Preliminary <br /> TAD P2+ AVG Per Match
                </Heading>
                <Metric
                  {...data.metric_preleminary_tad}
                  size={"lg"}
                  format="0,0"
                />
              </div>

              <div className="mb-5 col-6">
                <Heading size={4}>
                  Streaming Minutes <br />
                  Average Per Match
                </Heading>
                <Metric
                  {...data.metric_streaming_minutes_per_match}
                  size={"lg"}
                  format="0,0"
                />
              </div>

              <div className="col-6">
                <Heading size={4}>Preliminary Linear Persons 2+</Heading>
                <Metric
                  {...data.metric_preleminary_linear}
                  size={"lg"}
                  format="0,0"
                />
              </div>

              <div className="col-6">
                <Heading size={4}>
                  Total Streaming <br /> Minutes For Yesterday
                </Heading>
                <Metric
                  {...data.metric_total_streaming_minutes}
                  size={"lg"}
                  format="0,0"
                  widget__title
                  noselect
                />
              </div>
            </div>
          </div>

          {/* <div className="mt-4 col-12 col-lg-4 mt-lg-0">
            <div className="row">
              <div className="col-12">
                <Heading size={4}>
                  Total Streaming Minutes for
                  <br /> Yesterday
                </Heading>
                <div className="d-flex">
                  <div className="mt-4">
                    <BarChart
                      width={60}
                      height={220}
                      data={data.chart}
                      margin={{
                        top: 0,
                        right: 0,
                        left: 0,
                        bottom: 0,
                      }}
                    >
                      {renderBars(data.chart)}
                    </BarChart>
                  </div>

                  <div className="mt-auto ml-4 mr-4 w-100">
                    {renderMetrics()}
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </>
    );
  }
}

export default YesterdaysSummary;
